import invitedToCompleted from "./invitedToCompleted";

export default [...invitedToCompleted];
